// Victoria Road — palm logo motif: fade + scale reveal, then parallax
// drift, driven directly by scroll position (not a one-shot timed
// animation), so it can't be missed by scrolling quickly and it
// reverses cleanly if the visitor scrolls back up.
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var wrappers = document.querySelectorAll('.vr-logo-motif');
    if (!wrappers.length) return;

    // Respect reduced-motion preference: the CSS fallback already shows
    // a static, faint mark, so skip the scroll-driven work entirely.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var items = Array.prototype.map
      .call(wrappers, function (wrap) {
        return {
          section: wrap.closest('section') || wrap.parentElement,
          img: wrap.querySelector('img'),
        };
      })
      .filter(function (item) {
        return item.img && item.section;
      });

    if (!items.length) return;

    function clamp(v, min, max) {
      return Math.max(min, Math.min(max, v));
    }

    // 0..1 — stays at 0 until the section is roughly half scrolled
    // into the viewport, then reveals over the remaining scroll.
    // (start pushed 10% of viewport height earlier so the reveal
    // begins sooner as the section scrolls in)
    function entryProgress(rect, vh) {
      var start = vh * 0.6;
      var end = vh * 0.1;
      return clamp((start - rect.top) / (start - end), 0, 1);
    }

    // -1..1 — 0 when the section is centred in the viewport.
    function centeredProgress(rect, vh) {
      var mid = rect.top + rect.height / 2;
      var viewportMid = vh / 2;
      return clamp((viewportMid - mid) / (vh / 2 + rect.height / 2), -1, 1);
    }

    function update() {
      var vh = window.innerHeight;
      items.forEach(function (item) {
        var rect = item.section.getBoundingClientRect();
        var entry = entryProgress(rect, vh);
        var drift = centeredProgress(rect, vh);
        var opacity = entry * 0.65;
        var scale = 0.55 + entry * 0.45;
        var shift = drift * 90;
        item.img.style.opacity = opacity.toFixed(3);
        item.img.style.transform =
          'translate(-50%, calc(-50% + ' + shift.toFixed(1) + 'px)) scale(' + scale.toFixed(3) + ')';
      });
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }

    // Listen on `document` with capture:true rather than `window` — this
    // theme scrolls an inner wrapper element (not window/documentElement),
    // so a plain window scroll listener never fires. Scroll events don't
    // bubble, but they DO propagate to ancestors during the capture phase,
    // so listening on document with capture catches scrolling on any
    // descendant container as well as on window itself.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
